"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var version_1 = require("../version");
/**
 * Returns User Agent based on version and settings.
 */
function getUserAgent(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.publicKey, publicKey = _c === void 0 ? '' : _c, _d = _b.integration, integration = _d === void 0 ? '' : _d;
    var mainInfo = [version_1.default, publicKey].filter(Boolean).join('/');
    var additionInfo = ['JavaScript', integration].filter(Boolean).join('; ');
    return "UploadcareUploadClient/" + mainInfo + " (" + additionInfo + ")";
}
exports.getUserAgent = getUserAgent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/userAgent.js
// module id = 109
// module chunks = 70